export type Theme = "dark" | "light" | "auto";

export enum Variant {
  Green = "green",
  Pink = "pink",
  Blue = "blue",
  Orange = "orange",
  Bordeaux = "bordeaux",
  DarkGreen = "dark-green",
  DarkBlue = "dark-blue",
}
